import { render, staticRenderFns } from "./quetaDetail.vue?vue&type=template&id=2681664c&scoped=true&"
import script from "./quetaDetail.vue?vue&type=script&lang=js&"
export * from "./quetaDetail.vue?vue&type=script&lang=js&"
import style0 from "./quetaDetail.vue?vue&type=style&index=0&id=2681664c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681664c",
  null
  
)

export default component.exports